import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { loadUserProfile, loadUserProfileFailed, loadUserProfileSuccess } from "../actions/profile.actions";
import { UserService } from "src/app/services/user/user.service";
import { of } from "rxjs";

@Injectable()
export class ProfileEffects {
	private actions$ = inject(Actions);
	private userService = inject(UserService);


	// Load the portal product catalog from backend blob storage
	loadProfile$ = createEffect(() => this.actions$.pipe(
		ofType(loadUserProfile),
		switchMap(() =>
			this.userService.loadUserProfile().pipe(
				switchMap(async resp => {
					resp.data.photo.url = this.userService.getImageWithoutCache(resp.data.photo.url);
					return loadUserProfileSuccess({ profile: resp.data });
				}),
				catchError(error => of(loadUserProfileFailed({ error })))
			)
		)
	));

}
